<div mat-dialog-content>
    <div class="controlPanel-container-button">
        <button mat-icon-button (click)="close()">
            <mat-icon>clear</mat-icon>
        </button>
    </div>
    <p class="title">Listado de Tableros de Control</p>
    <table class="controlPanel-table" mat-table [dataSource]="dataSource" #table>
        <ng-container matColumnDef="Id">
            <th mat-header-cell *matHeaderCellDef>Id</th>
            <td mat-cell *matCellDef="let item">{{item.id}}</td>
        </ng-container>
        <ng-container matColumnDef="Nombre">
            <th mat-header-cell *matHeaderCellDef>Nombre</th>
            <td mat-cell *matCellDef="let item">{{item.name}}</td>
        </ng-container>
        <ng-container matColumnDef="Asignar">
            <th mat-header-cell *matHeaderCellDef>Asignar</th>
            <td mat-cell *matCellDef="let item">
                <div class="controlPanel-container-checkbox" matRipple [matRippleCentered]="true" [matRippleRadius]="40">
                    <div class="controlPanel-checkbox">
                        <input [id]="item.id" type="checkbox" [checked]="item.active" (click)="checked($event.srcElement,item.id)">
                        <label class="controlPanel-label" [for]="item.id">
                            <mat-icon>done</mat-icon>
                        </label>
                    </div>
                </div>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columns"></tr>
        <tr mat-row *matRowDef="let row; columns: columns;"></tr>
    </table>
</div>